import React from 'react';
import { observer } from 'mobx-react';
import { Intent } from '@blueprintjs/core';
import Tooltip from 'core/components/Tooltip';

const getFormErrorsTooltipProps = ({ form, displayErrors }) => {
  const { valid } = form;

  let content;

  if (!valid) {
    content = (
      <ul style={{ marginBlockStart: 4, marginBlockEnd: 4, paddingInlineStart: 20, maxWidth: 600 }}>
        {displayErrors.map((error) => (
          <li key={error}>{error}</li>
        ))}
      </ul>
    );
  }

  return {
    content,
    intent: Intent.DANGER
  };
};

const FormErrorsButton = ({ form, errors, button, errorRenderer, ...extraTooltipProps }) => {
  const { valid, errors: formErrors } = form;
  const displayErrors = errorRenderer ? errorRenderer(formErrors) : errors || formErrors;
  const tooltipProps = { ...getFormErrorsTooltipProps({ form, displayErrors }), ...extraTooltipProps };
  const ariaProps = {};
  if (!valid) {
    ariaProps['aria-label'] = `Form has errors: ${(errors || formErrors).map((error) => ({ error }))}`;
  }
  if (tooltipProps.content) {
    return (
      <Tooltip {...tooltipProps} aria-live="assertive" role="tooltip">
        {button}
      </Tooltip>
    );
  }

  return button;
};

export default observer(FormErrorsButton);
